export function partnerFormInit(){
  if($('.donation-form').length){
    const form = $('.donation-form .wpcf7-form')
    const result = $('.partner-form__result')

    if(result.length){
      const defaultMsg = result.text()
      const icon = ' <i class="icon-checked color--green"></i>'
      $('.donation-form .wpcf7-response-output').hide()

      form.on('wpcf7mailsent', function(event){
        let msg = event.detail.apiResponse.message || defaultMsg
        result.html(msg + icon)
      })

      form.on('wpcf7mailfailed wpcf7spam wpcf7invalid', function(event){
        let msg = event.detail.apiResponse.message
        result.html(msg)
      })

    }
  }
}